/**
 * "Listing only" mode for local spikes where only the vehicle listing backend is running
 * (see Carbar-Systems/carbar-listing-node). When NUXT_PUBLIC_LISTING_ONLY=true the campaign
 * banner and the sign-in / join buttons are hidden because the endpoints behind them are down.
 */
export const useIsListingOnly = (): boolean => {
	const value = String(useRuntimeConfig().public.LISTING_ONLY).toLowerCase()
	return ['true', '1'].includes(value)
}
